<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-card-title class="d-flex justify-end">
          <v-btn class="mx-2" fab dark small color="primary" @click="close">
            <v-icon dark> mdi-close-circle-outline </v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-container class="d-flex justify-center">
            <embed :src="url" width="500" height="375" type="application/pdf" />
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  name: "PreviewPdf",
  props: ["url", "isDialog"],
  data: () => ({
    dialog: false,
  }),
  watch: {
    isDialog() {
      this.dialog = this.isDialog;
    },
  },
  created() {
    this.dialog = this.isDialog;
  },
  methods: {
    close() {
      this.$emit("closeDialog");
    },
  },
};
</script>
